import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { DateRange } from 'react-date-range';
import React, { useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';

const DateRangePicker = (props) => {

    const [state, setState] = useState([
        {
            startDate: null,
            endDate: null,
            key: 'selection',
        }
    ]);

    const setFromDate = props?.setFromDate;
    const setToDate = props?.setToDate;
    const selectedItem = props?.selectedItem;
    const poolAcntNbr = props?.poolAcntNbr;
    const setShowCalender = props?.setShowCalender;
    const vehicleLength = props?.vehicleLength;
    const setAlertModalVisible = props?.setAlertModalVisible;
    const setAlertModal = props?.setAlertModal;
    const className = props?.className;

    const handleSelect = (date) => {
        console.log(date);
        if (!isNaN(date.selection.endDate)) {
            const startDate = new Date(moment(date.selection.startDate).format("MM/DD/YYYY"));
            const endDate = new Date(moment(date.selection.endDate).format("MM/DD/YYYY"));
            const diffTime = Math.abs(endDate - startDate);
            const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

            if (diffDays > 30) {
                setAlertModalVisible(true);
                setAlertModal({
                    title: "Error",
                    status: "error",
                    message: "Please select a date range of one month.",
                    navigateScreen: "Statement",
                    actionButton: "OK"
                });
                return;
            }

            if (selectedItem === poolAcntNbr || selectedItem === "Consolidated") {
                if (vehicleLength > global.MAX_VRN_COUNT_PORTAL_STMT) {
                    if (diffDays > 30) {
                        setAlertModalVisible(true);
                        setAlertModal({
                            title: "Error",
                            status: "error",
                            message: "Please select a date range of one month.",
                            navigateScreen: "Statement",
                            actionButton: "OK"
                        });
                        return;
                    }
                }
            }

            setToDate(date.selection.endDate);
            if (date.selection.startDate) {
                setShowCalender(false);
            }
        } else {
            setState([date.selection]);
            setFromDate(date.selection.startDate);
        }
    };

    return (
        <>



            <DateRange
                onChange={item => handleSelect(item)}
                moveRangeOnFirstSelection={true}
                ranges={state}
                minDate={new Date(moment().subtract(365, "days").format())} maxDate={new Date(moment().subtract(`${global.statement_filter_days}`, "days").format())}
                startDatePlaceholder={"Start date"} endDatePlaceholder={"End date"}
                retainEndDateOnFirstSelection={false}
                rangeColors={['#9c1d25']}
                className={className}
            /></>
    );
};
export default DateRangePicker;

